import AccesRapide from "./AccesRapide";

const HelpTopicOptimizeAnnonce = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Optimisez votre annonce', link: '/topics/compte'},
  ];

  const content = <>
    <p className="help-text">
      Découvrez ce guide incontournable pour ajuster ou perfectionner votre annonce de compétition. Il contient toutes les informations sur le fonctionnement 
      de Wodzone et des conseils pour configurer vos paramètres afin d’optimiser votre visibilité et votre expérience sur la plateforme.
    </p>
    <p className="mt-48 fw-600 fz-20 mb-12">Maîtriser votre Dashboard Admin</p>
    <p className="help-text">
      Une fois votre<a target='_blank' className="link" href={`/topics/about/3`}>token</a>obtenu, vous avez accès à votre
      <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/app/dashboard`}>portail admin,</a> configurer 
      votre compétition comme un WOD bien épicé !
    </p>
    <p className="help-text border-bottom pb-32 mb-0">
      C'est ici que tout ce passe. Du paramétrage des WODs à la gestion des équipes, tout est réuni ici pour vous permettre de concevoir une compétition sur mesure, 
      à la hauteur de vos ambitions.
    </p>
  </>

  return (
    <AccesRapide 
      goBackLinks={goBackLinks} guideInfo='Guide • Organisateur' 
      img="/images/optimize.webp" content={content} topicsIds={[3, 53, 54]}
    />
  );
}

export default HelpTopicOptimizeAnnonce